import * as DocModels from './Models/DocumentModel';

import { getJson, putJson, postJson } from './ChoiceApi';

export const documents = {
    async getDocumentQueueList(isMarkedDel: boolean): Promise<DocModels.IDocumentUnsolicitedQueueResponse[]> {
        return await getJson(`api/documents?markedForDeletion=${isMarkedDel}`) as DocModels.IDocumentUnsolicitedQueueResponse[];
    },

    async deleteDocuments(payload: DocModels.IDocumentIdArray[], securityScreenId: number, screenName: string, authUser: string): Promise<void> {
        await putJson(`api/documents/mark/${securityScreenId}/${screenName}/${authUser}`, payload);  
    },

    async getDocument(documentId: number): Promise<DocModels.IDocumentUnsolicitedQueueResponse> {
        return await getJson(`api/documents/${documentId}`) as DocModels.IDocumentUnsolicitedQueueResponse;
    },

    async getDocumentReviewers(documentId: number): Promise<DocModels.IUnsolicitedDocumentSetupReviewerListResponse[]> {
        return await getJson(`api/documents/reviewers/${documentId}`) as DocModels.IUnsolicitedDocumentSetupReviewerListResponse[];
    },

    async updateDocument(payload: DocModels.IUnsolicitedDocumentSaveRequest, securityScreenId: number, screenName: string): Promise<void> {
        await putJson(`api/documents/${payload.documentId}/${securityScreenId}/${screenName}`, payload);  
    },

    async auditDocument(documentId: number): Promise<DocModels.IUnsolicitedDocumentAuditResponse> {
        return await getJson(`api/documents/audit/${documentId}`) as DocModels.IUnsolicitedDocumentAuditResponse;
    },

    async getApiKeyDocumentSetupList(): Promise<DocModels.IUnsolicitedDocumentSetupApiKeyListResponse[]> {
        return await getJson(`api/Setup/UnsolicitedDocument/ListKeys`) as DocModels.IUnsolicitedDocumentSetupApiKeyListResponse[];
    },

    async getApiKeyDocumentSetupReviewerList(): Promise<DocModels.IUnsolicitedDocumentSetupReviewerListResponse[]> {
        return await getJson(`api/Setup/UnsolicitedDocument/ListReviewers`) as DocModels.IUnsolicitedDocumentSetupReviewerListResponse[];
    },

    async saveDocumentSetup(payload: DocModels.IUnsolicitedDocumentSetupSaveRequest): Promise<number> {
        return (await postJson(`api/Setup/UnsolicitedDocument/SaveSetup`, payload)) as number;
    },

}